import apiClient from "./apiClient";

export function getSeatAvailability(routeId, travelDate) {
  return apiClient.get(`/bookings/availability/${routeId}`, {
    params: { travelDate },
  });
}

export function createBooking(payload) {
  return apiClient.post("/bookings/create", payload);
}

export function getCustomerDashboard() {
  return apiClient.get("/bookings/my-dashboard");
}

export function getMyBookings(filter) {
  return apiClient.get("/bookings/my-bookings", { params: { filter } });
}

export function cancelBooking(bookingId) {
  return apiClient.put(`/bookings/${bookingId}/cancel`);
}
